import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PasswordForgotComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/password-widgets/password-forgot/password-forgot.component';
import { CardAuthenticationReviewComponent } from './Modules/shared/card-authentication-review/card-authentication-review.component';
import { FeatureRedirectComponent } from './feature-redirector/feature-redirect.component';
import { LoginComponent } from './lib/components/login/login.component';
import { PostAuthComponent } from './lib/components/post-auth/post-auth.component';
import { ConfirmationCodeComponent } from './Modules/shared/confirmation-code/confirmation-code-component/confirmation-code.component';
import { GoCardlessPispDepositStatusComponent } from './Modules/shared/gocardless-pisp-deposit-status/gocardless-pisp-deposit-status.component';
import { NominatedAccountStatusComponent } from './Modules/shared/nominated-account-status/nominated-account-status.component';
import { EmailVerificationComponent } from './Modules/shared/widgets/email-verification/email-verification.component';
import { CloudflareTurnstileComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/cloudflare-turnstile/cloudflare-turnstile.component';

const routes: Routes = [
  {
    path: 'zones',
    loadChildren: () => import('./Modules/zones/zones.module').then((mod) => mod.ZonesModule),
  },
  {
    path: 'verify-email/:token',
    component: EmailVerificationComponent,
  },
  {
    path: 'forgot-password/:token',
    component: PasswordForgotComponent,
  },
  {
    path: 'confirmation-code',
    component: ConfirmationCodeComponent,
  },
  {
    path: 'card-authentication-review/:authenticationId',
    component: CardAuthenticationReviewComponent,
  },
  {
    path: 'nominated-account-status',
    component: NominatedAccountStatusComponent,
  },
  {
    path: 'pisp-deposit-status',
    component: GoCardlessPispDepositStatusComponent,
  },
  {
    // Return leg of a custom widget's redirect hand-off (?handoffId=...); it
    // resolves the outcome, then routes back to the page hosting the widget.
    path: 'widget-handoff-return',
    loadComponent: () =>
      import('./Modules/shared/widgets/custom-widget/widget-handoff-return.component').then(
        (component) => component.WidgetHandoffReturnComponent,
      ),
  },
  {
    path: 'feature-redirect/:zone/:role/:subscription',
    component: FeatureRedirectComponent,
  },
  {
    path: 'feature-redirect/:zone/:role/:subscription/:onboardingOrgId',
    component: FeatureRedirectComponent,
  },
  {
    path: 'feature-redirect',
    component: FeatureRedirectComponent,
  },
  {
    path: 'organisation-onboarding-completion/:onboardingOrgId',
    loadChildren: () =>
      import('./Modules/shared/organisation-module/organisation.module').then(
        (module) => module.OrganisationPageModule,
      ),
  },
  {
    path: 'associate-user-organisation/:onboardingOrgId',
    loadComponent: () =>
      import('./Modules/shared/organisation-module/associate-user-organisation/associate-user-organisation.component').then(
        (component) => component.AssociateUserOrganisationComponent,
      ),
  },
  {
    path: 'post-auth',
    component: PostAuthComponent,
  },
  {
    path: 'post-auth/:redirectionFlow',
    component: PostAuthComponent,
  },
  { path: 'turnstile-spike', component: CloudflareTurnstileComponent },
  {
    path: 'invitations',
    loadComponent: () =>
      import('./Modules/shared/invitation-redirection-handler/invitation-redirection-handler.component').then(
        (component) => component.InvitationRedirectionHandlerComponent,
      ),
  },
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: '**',
    component: LoginComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollOffset: [0, 80],
      scrollPositionRestoration: 'enabled',
      initialNavigation: 'enabledNonBlocking',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
